import React, { Fragment, useRef } from 'react';
import { ToastProvider } from 'react-toast-notifications';
import { Row, Form } from 'react-bootstrap';
import language from '../../config/es';
import { es_entero, es_vacio } from '../../config/validate';
//Permissions
import dictionary from '../../config/dictionary';
//redux
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import {
  getPermissions,
  findByEntity,
  saveChannelTransaction,
  updateChannelTransaction,
  deleteChannelTransaction,
  clearData,
} from '../../redux/channelTransaction.duck';
import { findChannel } from '../../redux/channel.duck';
import app from '../../config/application';
import { findByConcept } from '../../redux/channelEntityPayment.duck';
import { findBySocieties } from '../../redux/branch.duck';
import { findCountries } from '../../redux/society.duck';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  useCrudState,
  usePermissionGate,
} from '../../components/Crud/crudHooks';
import {
  buildEditColumn,
  addFieldError,
  renderDeleteAction,
  requireSelection,
  saveActionOf,
  stampRows,
} from '../../components/Crud/crudHelpers';
import {
  CountrySelect,
  RequiredFieldsAlertLegacy,
  SelectField,
  TextField,
} from '../../components/Crud/CrudFields';
import {
  CrudButtons,
  CrudDataTable,
  CrudLoadingScreen,
  CrudPage,
  WIDE_TABLE_COLS,
} from '../../components/Crud/CrudLayout';

const ChannelTransaction = () => {
  const ref = useRef();
  const dispatch = useAppDispatch();

  //propiedades ---------------------------------------------------
  const {
    data,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
    initStateDelete,
    reloadWith,
    finishDelete,
    prepareSave,
  } = useCrudState({
    collectingEntity: { value: 0, label: '', error: '', auth: '' },
    country: { value: 0, label: '', error: '', auth: '' },
    channelEntity: { value: 0, label: '', error: '', auth: '' },
    typeId: { value: 0, label: '', error: '', auth: '' },
    timeExpiration: { value: '0', error: '' },
    timeNull: { value: '0', error: '' },
    showloadingCollectingEntity: true,
    showloadingCountry: false,
    showLoadingTypes: false,
    showLoadingChannel: true,
    pendingData: false,
    enable: false,
    name: { value: '', error: '' },
    code: { value: '', error: '' },
    dataRows: [],
    errors: [],
    columns: [],
    collectingEntities: [],
    typeIds: [],
    channels: [],
    selectedRows: [],
    id: null,
    showDelete: false,
    action: dictionary.configApp.action,
    auth: JSON.parse(sessionStorage.getItem('user')),
  });

  data.typeIds = useSelector((store) => store.typeReducer.types);
  data.collectingEntities = useSelector(
    (store) => store.collectingEntityReducer.cEntities
  );
  data.country.auth = useSelector((store) => store.branchReducer.errorResponse);
  data.countries = useSelector((store) => store.societyReducer.countries);
  data.channels = useSelector((store) => store.channelReducer.channels);
  data.dataRows = useSelector(
    (store) => store.channelTransactionReducer.channelTransactions
  );
  //ciclo de vida ---------------------------------------------------
  const { loadInit, msgRestricted, withPermission } = usePermissionGate({
    ref,
    data,
    dispatch,
    getPermissions,
    notify: viewNotification,
    onAllowed: () => {
      initColumns();
      void initData();
    },
  });
  const initData = async () => {
    await loadTypes();
    await loadCountries();
    data.enable = true;
    refreshState();
  };
  //#region handler
  const onChange = (event) => {
    switch (event.target.name) {
      case 'timeExpiration':
        data.timeExpiration.value = event.target.value;
        break;
      case 'timeNull':
        data.timeNull.value = event.target.value;
        break;

      default:
        break;
    }
    refreshState();
  };

  const handleButtonEdit = (row) => {
    data.id = row.id;
    data.channelEntity = {
      value: row.channelCEntity.id,
      label: row.channelCEntity.type.name.toUpperCase(),
      error: '',
    };
    data.typeId = {
      value: row.transactionType.id,
      label: row.transactionType.name.toUpperCase(),
      error: '',
    };
    data.timeExpiration = {
      value: Number.parseInt(row.expirationTime),
      error: '',
    };
    data.timeNull = {
      value: Number.parseInt(row.expirationAnnulation),
      error: '',
    };
    refreshState();
  };
  const handleDelete = () => {
    void disableData();
  };
  //#endregion

  //functions ---------------------------------------------------
  const contextActions = renderDeleteAction(handleDelete, data.enable);

  const loadCountries = async () => {
    await dispatch(findCountries(data.auth.id.user.userId));
    data.showloadingCountry = true;
  };
  const clearError = async () => {
    data.errors = [];
    data.collectingEntity.error = '';
    data.channelEntity.error = '';
    data.typeId.error = '';
  };

  const updateSelect = async (value, id) => {
    switch (id) {
      case 'collectingEntity':
        data.collectingEntity = value;
        data.channelEntity = { value: 0, label: '', error: '' };
        data.channels = [];
        data.dataRows = [];
        data.pendingData = true;
        data.showLoadingChannel = false;
        refreshState();
        await loadChannels();
        await loadChannelTransaction();
        data.pendingData = false;
        data.showLoadingChannel = true;
        break;
      case 'channel':
        data.channelEntity = value;
        break;
      case 'type':
        data.typeId = value;
        break;
      case 'country':
        data.country = value;
        data.collectingEntity = { value: 0, label: '', error: '', auth: '' };
        data.dataRows = [];
        updateState(false, 'showloadingCollectingEntity');
        await dispatch(clearData());
        await loadCollectingEntities();
        data.showloadingCollectingEntity = true;
        break;
      default:
        break;
    }
    initColumns();
    refreshState();
  };

  const loadChannelTransaction = async () => {
    updateState(true, 'pendingData');
    try {
      data.dataRows = await dispatch(findByEntity(data.collectingEntity.value));
      if (data.dataRows.length > 0 && data.dataRows[0].code !== undefined) {
        viewNotification(data.dataRows[0].message, 'error');
        data.dataRows = [];
      }
    } catch (err) {
      console.error(err);
      data.dataRows = [];
    }

    updateState(false, 'pendingData');
  };

  const loadCollectingEntities = async () => {
    data.showloadingCollectingEntity = false;
    await dispatch(findBySocieties(data.country.value));
    updateState(true, 'showloadingCollectingEntity');
  };

  const loadTypes = async () => {
    await dispatch(findByConcept(app.data.types.channelTransaction));
    data.showLoadingTypes = true;
    updateState(true, 'showLoadingTypes');
  };

  const loadChannels = async () => {
    data.showLoadingChannel = false;
    await dispatch(findChannel(data.collectingEntity.value));
    data.showLoadingChannel = true;
    updateState(true, 'showLoadingChannel');
  };

  const initColumns = () => {
    data.columns = [
      buildEditColumn(handleButtonEdit, {
        name: language.messages.lblFunctions,
      }),
      {
        name: language.messages.channel.lblChannel,
        sortable: false,
        wrap: true,
        cell: (row) => (
          <span>
            <div className="text-primary text-uppercase small">
              {row.channelCEntity.type.name.toUpperCase()}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.type.title,
        sortable: false,
        wrap: true,
        cell: (row) => (
          <span>
            <div className="text-dark text-uppercase small">
              {row.transactionType.name.toUpperCase()}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.channelTransaction.lbl_expiration,
        sortable: false,
        wrap: true,
        cell: (row) => (
          <span>
            <div className="text-dark text-uppercase small">
              {row.expirationTime}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.channelTransaction.lbl_annulation,
        sortable: false,
        wrap: true,
        cell: (row) => (
          <span>
            <div className="text-dark text-uppercase small">
              {row.expirationAnnulation}
            </div>
          </span>
        ),
      },
    ];
    refreshState();
  };

  const reloadDataEnable = async () => {
    await loadChannelTransaction();
    refreshState();
  };

  const validate = () => {
    void clearError();

    requireSelection(data, ['collectingEntity']);

    if (data.typeId.value === 0) {
      addFieldError(
        data,
        'typeId',
        language.messages.error_no_selected,
        'type'
      );
    }

    requireSelection(data, ['channelEntity']);

    if (
      es_vacio(data.timeExpiration.value) ||
      !es_entero(data.timeExpiration.value)
    ) {
      data.errors.push('timeExpiration.error');
      data.timeExpiration.error = language.messages.error_numero;
    }
    if (es_vacio(data.timeNull.value) || !es_entero(data.timeNull.value)) {
      data.errors.push('timeNull.error');
      data.timeNull.error = language.messages.error_numero;
    }

    refreshState();
  };

  const clearForm = () => {
    data.typeId = { value: 0, label: '', error: '' };
    data.channelEntity = { value: 0, label: '', error: '' };
    data.timeExpiration = { value: '0', error: '' };
    data.timeNull = { value: '0', error: '' };
    data.id = null;
    refreshState();
  };

  const enableWithNotification = (message, type) => {
    updateState(true, 'enable');
    viewNotification(message, type);
  };

  const handleSaveSuccess = async () => {
    updateState(true, 'pendingData');
    await reloadData();
    viewNotification(language.messages.msmRegisterSuccessFully, 'success');
    clearForm();
    updateState(false, 'pendingData');
  };

  const handleSaveResponse = async (response) => {
    if (response.status !== 200) {
      enableWithNotification(response.messageResponse, 'error');
    } else if (response.data === 'EXIST') {
      enableWithNotification(language.messages.msmExistRegister, 'warning');
    } else {
      await handleSaveSuccess();
    }
  };

  const saveData = async () => {
    prepareSave(validate);

    await withPermission(saveActionOf(data), async () => {
      if (data.errors.length === 0) {
        updateState(false, 'enable');
        let json = {
          id: data.id,
          status: 1,
          userAdmin: sessionStorage.getItem('username'),
          societyId: data.country.value,
          channelCEntity: { id: data.channelEntity.value },
          transactionType: { id: data.typeId.value },
          expirationTime: data.timeExpiration.value,
          expirationAnnulation: data.timeNull.value,
        };

        let response = '';
        if (data.id === null) {
          response = await dispatch(saveChannelTransaction(json));
        } else {
          response = await dispatch(updateChannelTransaction(json));
        }

        await handleSaveResponse(response);
      }
    });
  };
  const disableData = async () => {
    data.enable = false;
    refreshState();
    
    if (data.selectedRows.length > 0) {
      await withPermission(data.action.delete, async () => {
        stampRows(data.selectedRows, { userAdmin: data.auth.id.user.userId });
        initStateDelete(false);

        let response = await dispatch(
          deleteChannelTransaction(data.selectedRows)
        );

        finishDelete(
          response.status === 200,
          language.messages.msmErrorServer,
          reloadData
        );
      });
    }
  };
  const cleaningForm = () => {
    void clearError();
    clearForm();

    viewNotification(language.messages.success_clean_data, 'success');
  };
  const reloadData = () => reloadWith(loadChannelTransaction);
  return (
    <Fragment>
      <br />
      <SessionConfig ref={ref} />
      {loadInit === true ? (
        <CrudLoadingScreen msgRestricted={msgRestricted} />
      ) : (
        <CrudPage
          {...WIDE_TABLE_COLS}
          formTitle={
            language.messages.channelTransaction.title_channel_transaction
          }
          form={
            <Form autoComplete="off">
              <RequiredFieldsAlertLegacy />

              <CountrySelect
                data={data}
                col={{ xl: 12 }}
                onChange={updateSelect}
              />
              <Row>
                {' '}
                <SelectField
                  col={{ xl: 12 }}
                  label={language.messages.titleCEntityForm}
                  loading={data.showloadingCollectingEntity}
                  isDisabled={data.id !== null}
                  name="collectingEntity"
                  options={data.collectingEntities}
                  className="text-uppercase small text-primary"
                  field={data.collectingEntity}
                  showAuth
                  onChange={updateSelect}
                  changeKey="collectingEntity"
                />
              </Row>

              <SelectField
                row
                col={{ md: 12 }}
                inlineLoading
                label={language.messages.channel.lblChannel}
                loading={data.showLoadingChannel}
                name="channel"
                options={data.channels}
                className="text-uppercase small text-primary"
                field={data.channelEntity}
                showAuth
                onChange={updateSelect}
                changeKey="channel"
              />
              <SelectField
                row
                col={{ md: 12 }}
                label={language.messages.type.title}
                loading={data.showLoadingTypes}
                name="typeId"
                options={data.typeIds}
                className="text-uppercase small text-primary"
                field={data.typeId}
                showAuth
                onChange={updateSelect}
                changeKey="type"
              />

              <Row>
                <TextField
                  col={{ md: 6, sm: 12 }}
                  label={language.messages.channelTransaction.time_expiration}
                  name="timeExpiration"
                  maxLength="4"
                  field={data.timeExpiration}
                  onChange={onChange}
                />
                <TextField
                  col={{ md: 6, sm: 12 }}
                  label={language.messages.channelTransaction.time_null}
                  name="timeNull"
                  maxLength="4"
                  field={data.timeNull}
                  onChange={onChange}
                />
              </Row>

              <CrudButtons
                data={data}
                withLoading
                primary
                reloadIcon="fa-refresh"
                onSave={saveData}
                onClear={cleaningForm}
                onReload={reloadDataEnable}
              />
            </Form>
          }
          tableTitle={
            language.messages.channelTransaction.title_document_type_register
          }
          table={
            <CrudDataTable
              data={data}
              title={data.collectingEntity.label}
              rows={data.dataRows}
              scrollHeight="500px"
              onSelect={handleSelectRow}
              actions={contextActions}
            />
          }
        />
      )}
    </Fragment>
  );
};

const App = () => (
  <ToastProvider>
    <ChannelTransaction />
  </ToastProvider>
);
export default App;
